import thumbnail1 from '../../images/video-thumbnails/sign-up.png';
import thumbnail2 from '../../images/video-thumbnails/booking.png';
import thumbnail3 from '../../images/video-thumbnails/before-booking.png';
import thumbnail4 from '../../images/video-thumbnails/during-booking.png';
import thumbnail5 from '../../images/video-thumbnails/maximize-earnings.png';
import thumbnail6 from '../../images/video-thumbnails/end-booking.png';
import signup from '../../constants/video-captions/signup.vtt';
import bookingPricing from '../../constants/video-captions/booking-pricing.vtt';
import beforeBooking from '../../constants/video-captions/before-booking.vtt';
import duringBooking from '../../constants/video-captions/during-booking.vtt';
import earning from '../../constants/video-captions/earning.vtt';
import endBooking from '../../constants/video-captions/end-booking.vtt';

const signUpDescription = [
  'Download the Autzu app, sign up, and ensure phone compatibility.',
  'Verify identity with license photo and selfie.',
  'Link your rideshare driver account.'
];

const bookingAndPricingDescription = [
  'Book through the Autzu app, select payment method and slots.',
  'Charges apply only before booking starts.',
  'Booking extensions and cancellations are easy.'
];

const beforeYourBookingDescription = [
  'Pack essentials, dress comfortably, update apps.',
  'Arrive on time, free parking for personal car.',
  'Use the Autzu app for vehicle check-in and inspection.'
];

const duringYourBookingDescription = [
  'Start the car through the Autzu app.',
  'Use the car console to find the nearest supercharging station.',
  'Auto-handling of charging costs by the Autzu app.'
];

const maximizingEarningsDescription = [
  'Drive in busy areas during peak times.',
  'Adhere to speed limits to conserve battery.',
  'Engage in referral programs, be on time to avoid unnecessary fees.'
];

const endingYourBookingDescription = [
  'Return car with minimum 70% battery.',
  'Lock the car via the Autzu  app, confirm the parking location.',
  'Finalize booking with a snapshot.'
];

const cityCodeGenerator = (country, state, city) => {
  if (country === 'US') {
    if (state === 'CA') {
      return 'sf';
    } else if (state === 'NY') {
      return 'nyc';
    } else {
      return 'la';
    }
  } else if (country === 'CA') {
    if (city === 'Toronto') {
      return 'tor';
    } else {
      return 'ott';
    }
  }
};

const videoTitleTool = pathName => {
  if (pathName.includes('signup')) {
    return 'Sign up';
  } else if (pathName.includes('bookingandpricing')) {
    return 'Booking and Pricing';
  } else if (pathName.includes('beforebooking')) {
    return 'Before Your Booking';
  } else if (pathName.includes('duringbooking')) {
    return 'During Your Booking';
  } else if (pathName.includes('maximizingearnings')) {
    return 'Maximizing Earnings';
  } else if (pathName.includes('endingbooking')) {
    return 'Ending Your Booking';
  }
};

const thumbnailTool = pathName => {
  if (pathName.includes('signup')) {
    return thumbnail1;
  } else if (pathName.includes('bookingandpricing')) {
    return thumbnail2;
  } else if (pathName.includes('beforebooking')) {
    return thumbnail3;
  } else if (pathName.includes('duringbooking')) {
    return thumbnail4;
  } else if (pathName.includes('maximizingearnings')) {
    return thumbnail5;
  } else if (pathName.includes('endingbooking')) {
    return thumbnail6;
  }
};

const videoSourceFinder = pathName => {
  if (pathName.includes('signup')) {
    return 'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/signing_up.mp4';
  } else if (pathName.includes('bookingandpricing')) {
    return 'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/booking.mp4';
  } else if (pathName.includes('beforebooking')) {
    return 'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/before_your_booking.mp4';
  } else if (pathName.includes('duringbooking')) {
    return 'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/during_your_booking.mp4';
  } else if (pathName.includes('maximizingearnings')) {
    return 'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/maximizing_earnings.mp4';
  } else if (pathName.includes('endingbooking')) {
    return 'https://d1ngkkk2ntpizc.cloudfront.net/walkthrough_final/ending_your_booking.mp4';
  }
};

export {
  signUpDescription,
  bookingAndPricingDescription,
  beforeYourBookingDescription,
  duringYourBookingDescription,
  maximizingEarningsDescription,
  endingYourBookingDescription,
  cityCodeGenerator,
  thumbnail1,
  thumbnail2,
  thumbnail3,
  thumbnail4,
  thumbnail5,
  thumbnail6,
  signup,
  bookingPricing,
  beforeBooking,
  duringBooking,
  earning,
  endBooking,
  videoTitleTool,
  thumbnailTool,
  videoSourceFinder
};



// WEBPACK FOOTER //
// ./src/components/Videos/utils.js